import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8080/api";

export const axiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

let isHandlingSessionExpiry = false;
let refreshPromise = null;

const handleSessionExpiry = async () => {
  isHandlingSessionExpiry = true;
  try {
    await axiosInstance.post('/auth/logout');
  } catch (logoutError) {
    console.error('Session expiry logout failed:', logoutError);
  } finally {
    window.location.href = '/login?sessionExpired=true';
  }
};

// Dedupes concurrent 401s so only one refresh call is in flight at a time.
const refreshSession = () => {
  if (!refreshPromise) {
    refreshPromise = axiosInstance.post('/auth/refresh').finally(() => {
      refreshPromise = null;
    });
  }
  return refreshPromise;
};

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const originalRequest = error.config || {};
    const isAuthEndpoint = (originalRequest.url || '').includes('/auth/');

    if (status === 401 && !isAuthEndpoint && !isHandlingSessionExpiry && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        await refreshSession();
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        await handleSessionExpiry();
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

